module.exports = __webpack_public_path__ + "img/logo3.de54593b.png";